import { queryOptions } from "@tanstack/react-query";
import { axiosInstance } from "./axios";
import { z } from "zod";

const periodKpiSchema = z.object({
    period: z.number(),
    teamId: z.number(),
    matchId: z.number(),
    distanceTravelled: z.number(),
    distanceTravelledWithPuck: z.number(),
    forwardDistanceTravelledWithPuck: z.number(),
    accelerations: z.number(),
    highAccelerations: z.number(),
    decelerations: z.number(),
    shots: z.number(),
    shotsOnGoal: z.number(),
    shotsWithScreen: z.number(),
    goals: z.number(),
    saves: z.number(),
    expectedGoals: z.number(),
    successfulPasses: z.number(),
    allPasses: z.number(),
    totalPassDistance: z.number(),
    forwardPassDistance: z.number(),
    puckContestsWon: z.number(),
    puckContestsLost: z.number(),
    totalPuckContests: z.number(),
    faceoffWins: z.number(),
    faceoffCount: z.number(),
    corsiForPercentage: z.number(),
    fenwickForPercentage: z.number(),
    pdo: z.number(),
    powerplayGoals: z.number(),
    powerplayCount: z.number(),
    penaltyKillGoalsAgainst: z.number(),
    penaltyKillCount: z.number(),
});

const periodDataResponseSchema = z.object({
    chosenPeriodKpis: z.array(periodKpiSchema),
    enemyTeamPeriodKpis: z.array(periodKpiSchema),
});

export type PeriodKpi = z.infer<typeof periodKpiSchema>;
export type PeriodDataResponse = z.infer<typeof periodDataResponseSchema>;

const fetchPeriodKpis = async (matchIds: number[], teamId?: number): Promise<PeriodDataResponse> => {
    const response = await axiosInstance.post("/matches/period/kpis", { matchIds, teamId });
    return periodDataResponseSchema.parse(response.data);
};

export const periodKpisQueryOptions = (matchIds: number[], teamId?: number) =>
    queryOptions({
        queryKey: ["period-kpis", matchIds, teamId],
        queryFn: () => fetchPeriodKpis(matchIds, teamId),
        staleTime: 5 * 60 * 1000,
    });
